// store/payment-context.js
import { createContext, useState } from "react";

const PaymentContext = createContext({
  channel: null,
  setChannel: () => {},
});

export const PaymentProvider = ({ children }) => {
  const [channel, setChannel] = useState(null);

  return (
    <PaymentContext.Provider value={{ channel, setChannel }}>
      {children}
    </PaymentContext.Provider>
  );
};

export default PaymentContext;
